import StringUtils from '@/util/StringUtils';

export default class HelperService {
  // eslint-disable-next-line class-methods-use-this
  getPaginatedLength(totalRows, perPage) {
    return Math.ceil(totalRows / perPage);
  }

  /**
   * Build a query string from a filters object using key value pairs
   * */
  // eslint-disable-next-line class-methods-use-this
  buildSearchQueryString(filters) {
    let query = '?';

    // eslint-disable-next-line no-restricted-syntax
    for (const key in filters) {
      if (filters[key] !== null && filters[key] !== undefined) {
        query += `${key}=${filters[key]}&`;
      }
    }

    query = query.substr(0, query.length - 1); // remove any extra '&' symbols

    return query;
  }

  /**
   * Get the filters from a page query,
   * requires a filter object containing the valid filters
   * to use (in case extra ones are applied which aren't recognised)
   * @param filters
   * @returns {*}
   */
  // eslint-disable-next-line class-methods-use-this
  getFiltersFromPageQuery(newFilters, query) {
    const pageParams = query;
    const filters = { ...newFilters };

    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const key in pageParams) {
      // eslint-disable-next-line no-prototype-builtins
      if (filters.hasOwnProperty(key)) {
        // eslint-disable-next-line no-param-reassign
        filters[key] = pageParams[key];
      }
    }

    return filters;
  }

  // eslint-disable-next-line class-methods-use-this
  setEndOfDay(dateStr) {
    const date = new Date(dateStr);
    date.setHours(23, 59, 59, 999);
    return date.toISOString();
  }

  // eslint-disable-next-line class-methods-use-this
  getReviewedBy(post) {
    if (post.status === 'Requested' || post.status === 'AwaitingConfirmation') {
      return '-'
    }
    if (post.reviewer && post.reviewer.name) {
      return StringUtils.toTitleCase(post.reviewer.name);
    }
    return 'System';
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}
